import { useState, useEffect } from 'react';
import { IconCheck } from '@tabler/icons-react';
import './Toast.css';

var listeners = [];
var toastId = 0;

export function showToast(message, type) {
  toastId++;
  listeners.forEach(function(fn) { fn({ id: toastId, message: message, type: type || 'success' }); });
}

export default function ToastContainer() {
  const [toasts, setToasts] = useState([]);

  useEffect(function() {
    function handler(toast) {
      setToasts(function(prev) { return prev.concat([toast]); });
      setTimeout(function() {
        setToasts(function(prev) { return prev.filter(function(t) { return t.id !== toast.id; }); });
      }, 3500);
    }
    listeners.push(handler);
    return function() {
      listeners = listeners.filter(function(fn) { return fn !== handler; });
    };
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container">
      {toasts.map(function(toast) {
        return (
          <div className={'toast toast--' + toast.type} key={toast.id}>
            {toast.type === 'success' && <IconCheck size={14} />}
            <span>{toast.message}</span>
          </div>
        );
      })}
    </div>
  );
}